<template>
  <!--  -->
  <QS-scroller-box v-loading="loading">
    <!--编辑 -->
    <div v-if="!isDetail">
      <p class="title">订单核算</p>
      <!-- 退车核算 -->
      <settleForm
        ref="settleFormRef"
        :performanceState="performanceState"
        :startDate="this.orderData.outStockTime"
        @moneyChange="setSettleMoney"
      />
      <!-- 网约运营信息 -->
      <operationalForm
        ref="operationalFormRef"
        @operationSumChange="getOperationMoney"
      />
      <!-- 支付款项 -->
      <payItems
        ref="payItemsRef"
        :surplusReceivableAmount="surplusReceivableAmount"
        @amountChange="setPayItemsAmount"
      />
      <!-- 核算结果 -->
      <settleResult
        :settleData="settleData"
        ref="settleResultRef"
        @settleResultUpdated="updateBizType"
      />
    </div>
    <!-- 详情 -->
    <checkoutOrder v-else />
    <template slot="bottomAction">
      <el-button size="small" @click="toBackPage">取消</el-button>
      <el-button
        v-if="isShowSubBtn"
        type="primary"
        size="small"
        :loading="saveLoading"
        @click="saveInfo"
        >保存</el-button
      >
      <template v-if="isShowSubBtn">
        <el-button
          type="primary"
          size="small"
          :loading="submitLoading"
          @click="submitInfo"
          >提交</el-button
        >
      </template>
    </template>
    <!-- 只有审批中 有 查看审批状态 -->
    <template slot="bottomAction" v-if="settleDetail.settlementState === 2">
      <el-button @click="lookApproval">查看审批动态</el-button>
    </template>
    <LookApprovalDetail
      ref="lookApprovalDetail"
      :bizId="settleDetail.bizId"
      :bizType="bizType"
    ></LookApprovalDetail>
  </QS-scroller-box>
</template>
<script>
import {
  addSettlement,
  confirmSettlement,
  vehiclesettlement,
} from '@/api/domain/returnLease'
import checkoutOrder from '../../../detail/components/checkoutOrder/old'
import LookApprovalDetail from './components/lookApprovalDetail'
import operationalForm from './components/operationalForm'
import payItems from './components/payItems'
import settleForm from './components/settleForm'
import settleResult from './components/settleResult'

import * as globalApi from '@/api/global'
import { debounce } from '@/utils'

export default {
  components: {
    settleForm,
    operationalForm,
    payItems,
    settleResult,
    checkoutOrder,
    LookApprovalDetail,
  },
  inject: ['orderData'],
  data() {
    return {
      // eslint-disable-next-line vue/no-unused-properties
      settleFormData: {},
      surplusReceivableAmount: 0, // 剩余租期车款
      settleData: {}, // 退车核算信息数据
      dingTalkShow: false,
      startDate: '',
      bizType: '',
      performanceState: false, // 履约状态 true履约/false未履约
      settleDetail: {}, // 退车单详情
      loading: false,
      saveLoading: false,
      submitLoading: false,
    }
  },
  provide() {
    return {
      settleDetail: this.settleDetail,
    }
  },
  mounted() {
    this.getSettleInfo(this.orderData.id)
  },
  computed: {
    // 是否展示保存和提交按钮，非核算中、订单状态待核算
    // 0 待核算 / 1 已完成 / 2 审批中 / 3 核算中 / 4 核算失败
    // 4500:核算中，5500:已关闭
    isShowSubBtn() {
      return (
        ![1, 2, 3].includes(this.settleDetail.settlementState) &&
        this.orderData.state === 4500
      ) // todo
    },
    // 是否详情态
    isDetail() {
      return [1, 2, 3].includes(this.settleDetail.settlementState)
    },
  },
  methods: {
    // 获取提交需要的数据
    getSubmitData() {
      const settle = this.$refs.settleFormRef.getData() // 获取核算表单内容
      const operation = this.$refs.operationalFormRef.getData() // 获取运营表单内容
      // eslint-disable-next-line no-shadow
      const payItems = this.$refs.payItemsRef.getData() // 获取支付项内容
      const result = this.$refs.settleResultRef.getSum() // 获取结算结果
      const {
        takeOverTime,
        isSettlementRefund,
        dailyRule,
        receivableAmount,
        toBeReceivedAmount,
        receivableDeposit,
        receivedDeposit,
      } = settle
      const {
        operationFlowDeduct,
        returnDepositCpt,
        returnCarAmountCpt,
        needAmountCpt,
      } = result
      const { operationFlowAmount, operationFlowPhotos, operationFlowRemarks } =
        operation
      const param = {
        orderId: this.orderData.id,
        takeOverTime, // 车辆交接完成时间
        isRentCarSettlement: isSettlementRefund, // 是否结算应退车款 1-是 0-否
        dailyRule, // 未足期日车款计算规则 0-期始月份自然天数计算 1-每月30天计算
        receivableDeposit: receivableDeposit || 0, // 应收押金
        receivedDeposit: receivedDeposit || 0, // 已收押金
        receivableAmount: receivableAmount || 0, // 应收车款
        toBeReceivedAmount: toBeReceivedAmount || 0, // 已收车款
        operationFlowDeduct, // 抵扣运营流水
        refundableDepositAmount: returnDepositCpt, // 应退押金
        needPatchAmount: needAmountCpt, // 需补欠款
        refundableRentAmount: returnCarAmountCpt || 0, // 应退车款
        approvalAccessModeType: this.dingTalkShow ? 2 : '', // 审批模式类型  2-提交钉钉审批 只有提交钉钉审批传2 其他都传空
        operationFlowAmount, // 运营流水
        operationFlowPhotos, // 运营图片
        operationFlowRemarks, // 备注
        settlementItems: payItems, // 支付款项
      }
      return param
    },
    // 保存
    saveInfo: debounce(async function () {
      if (this.saveLoading) return
      this.saveLoading = true
      try {
        await this.getDingTalkBtnStatus()
        const params = this.getSubmitData()

        if (this.performanceState && !params.takeOverTime) {
          this.$message.error('车辆完成交接时间不能为空！')
          return
        }
        await addSettlement(params).then((res) => {
          if (res.code !== 1) return
          this.$message.success('保存成功')
          this.$refreshBack(true)
        })
      } finally {
        this.saveLoading = false
      }
    }),
    /*
        向后端传递的参数（判断是应收/应付） bizType
        需补欠款大于 0 -- 应收审批
        应退押金 或 应退车款 大于 0 -- 应付审批
        需补欠款、应退押金、应退车款 都等于 0 -- 应收审批
        bizType 1 个人租赁应收审批 / 2租赁退车付款审批 / 3租赁退车收款审批 / 4支付宝支付解约 / 5网约钱包支付解约
      */
    initBizType() {
      // needPatchAmount:需补欠款,refundableDepositAmount:应退押金,refundableRentAmount:应退车款
      const {
        refundableDepositAmount = 0,
        refundableRentAmount = 0,
        needPatchAmount = 0,
      } = this.settleDetail
      let bizType
      if (
        Number(needPatchAmount) > 0 ||
        (Number(needPatchAmount) === 0 &&
          Number(refundableDepositAmount) === 0 &&
          Number(refundableRentAmount) === 0)
      ) {
        bizType = 3
      } else if (
        Number(refundableDepositAmount) > 0 ||
        Number(refundableRentAmount) > 0
      ) {
        // 应退押金 或 应退车款
        bizType = 2
      }
      this.bizType = bizType
    },
    updateBizType(val) {
      // needAmountCpt:需补欠款,returnDepositCpt:应退押金,returnCarAmountCpt:应退车款
      const {
        returnDepositCpt = 0,
        returnCarAmountCpt = 0,
        needAmountCpt = 0,
      } = val
      let bizType
      if (
        Number(needAmountCpt) > 0 ||
        (Number(needAmountCpt) === 0 &&
          Number(returnDepositCpt) === 0 &&
          Number(returnCarAmountCpt) === 0)
      ) {
        bizType = 3
      } else if (
        Number(returnDepositCpt) > 0 ||
        Number(returnCarAmountCpt) > 0
      ) {
        // 应退押金 或 应退车款
        bizType = 2
      }
      this.bizType = bizType
    },
    submitInfo: debounce(async function () {
      if (this.submitLoading) return
      const dingTalkShow = await this.getDingTalkBtnStatus()
      const params = this.getSubmitData()
      // 未履约退车不校验时间
      if (this.performanceState && !params.takeOverTime) {
        this.$message.error('车辆完成交接时间不能为空！')
        return
      }

      const message = dingTalkShow
        ? '确认后将提交审批，无法再次修改金额，财务审批通过后才可进行费用结算'
        : '确认后将提交到财务核算，将无法再次修改金额'

      this.$confirm(message, '确认是否提交', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.submitLoading = true
          confirmSettlement(params).then((res) => {
            if (res.code === 1) {
              this.$message.success('提交成功')
              // 如果是钉钉审批流不进行跳转，只更新当前页面状态
              setTimeout(() => {
                this.$refreshBack(true)
              }, 1200)
            } else if (res.code === 24012) {
              // 网约钱包支付提示
              this.$confirm(
                '有正在进行中的网约钱包支付,可等待网约钱包支付完成后再进行核算或手动终止',
                '提示',
                {
                  confirmButtonText: '去终止',
                  cancelButtonText: '取消',
                },
              ).then(() => {
                this.$refreshBack(true)
                // TODO: 待确认id
                this.$router.push({
                  path: '/finance/withholdPlanList',
                })
              }).catch(() => null)
            } else if (res.code === 24013) {
              // 支付宝支付提示
              this.$alert(
                '有正在进行中的支付宝支付,请完成支付宝支付后再进行核算',
                '提示',
                {
                  confirmButtonText: '关闭',
                  callback: () => null,
                },
              )
            }
          }).finally(() => {
            this.submitLoading = false
          })
        })
        .catch(() => null)
    }),
    // 获取结算详情
    getSettleInfo(orderId) {
      this.loading = true
      vehiclesettlement({ orderId })
        .then((res) => {
          this.loading = false
          if (res.code !== 1) return
          const data = res.data || {}
          Object.keys(data).forEach((key) => {
            this.$set(this.settleDetail, key, data[key])
          })
          this.surplusReceivableAmount = data.surplusReceivableAmount || 0
          this.performanceState = data.performanceState
          this.startDate = data.startDate || ''
          this.setSettleMoney(this.settleDetail)
          this.initBizType()
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 查询钉钉审批是否开通
    async getDingTalkBtnStatus() {
      let dingTalkShow
      try {
        const res = await globalApi.getSubmitDingTalkShow({
          bizType: this.bizType, // 业务类型
        })
        const { code, data } = res
        code === 1 && (dingTalkShow = data)
      } catch (err) {
        dingTalkShow = false
      }
      this.dingTalkShow = dingTalkShow

      return dingTalkShow
    },
    // 退车核算信息
    setSettleMoney(val) {
      this.surplusReceivableAmount = (val && val.surplusReceivableAmount) || 0
      this.settleData = val
    },
    // 支付款项总和
    setPayItemsAmount(val) {
      this.$refs.settleResultRef.setItemVal('payItemsSum', val)
    },
    // 运营流水
    getOperationMoney(val) {
      this.$refs.settleResultRef.setItemVal('operationFlowAmount', val)
    },
    // 取消
    toBackPage() {
      this.$refreshBack(false)
    },
    // 查看审批动态
    lookApproval() {
      // this.infoData.bizId
      this.$refs.lookApprovalDetail.dialogVisible = true
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  font-weight: 600;
  font-size: 16px;
  color: #323233;
  margin-bottom: 14px;
}
</style>
